module.exports = __webpack_public_path__ + "static/media/product-2-front.6cbb647a.jpg";